import { defaultSearchesProperties } from './init';
import { SearchesAction, SearchesActionTypes,  SearchesState } from '../types';

export const searches = (state: SearchesState = { ...defaultSearchesProperties }, action: SearchesActionTypes ) => {
  switch (action.type) {
    case SearchesAction.UPDATE_PLAYERS_SEARCH_DATA:
      return { ...state, playersData: action.playersData };
    case SearchesAction.UPDATE_COMBINE_PLAYERS_SEARCH_DATA:
      return {...state, playersCombineData:{[action.teamId]: action.playersCombineData}};
    default:
      return state;
  }
};